import React, { useState } from 'react'
import { SvgIcon } from 'components'
import Info from 'assets/info.svg?react'
import { Tooltip } from './components/tooltip'
import { Wrapper } from './style'
import { TooltipProps } from './interface'

/**
 * Icon tooltip, places an icon next to the text, and shows the tooltip when the icon is hovered
 * @param props
 * @returns
 */
export const ControlledTooltip: React.FC<TooltipProps> = (props) => {
  const [isActive, setActive] = useState(false)
  const { className, iconColor, children } = props

  const sanitizeEvent = (e: React.PointerEvent<HTMLDivElement>, value: boolean) => {
    // only show tooltip if the pointer is a mouse
    if (e.pointerType === 'mouse') {
      setActive(value)
    }
  }
  return (
    <Wrapper
      className={className}
      onPointerEnter={(e) => sanitizeEvent(e, true)}
      onPointerLeave={(e) => sanitizeEvent(e, false)}
    >
      {children ? children : <SvgIcon stroke={iconColor} icon={Info} iconSize={'tooltip'} />}
      {<Tooltip {...{ ...props, ...{ active: isActive } }} />}
    </Wrapper>
  )
}
